(function () {
  'use strict';

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getProductRoot() {
    return (
      $('[data-product-root]') ||
      $('[data-pdp-gallery]') ||
      $('.cm-pdp-top') ||
      $('.cm-pdp') ||
      document
    );
  }

  function getProductForm(root) {
    return (
      $('form[action*="/cart/add"]', root) ||
      $('form[action*="/cart/add"]') ||
      null
    );
  }

  function readVariantData() {
    var customEl = $('[data-cm-variant-map]');

    if (customEl) {
      try {
        return JSON.parse(customEl.textContent.trim());
      } catch (error) {
        console.warn('Custom variant map parse failed:', error);
      }
    }

    var el =
      $('[data-product-variants]') ||
      $('[data-mobile-sku-variants]');

    if (!el) return [];

    try {
      return JSON.parse(el.textContent.trim());
    } catch (error) {
      console.warn('Variant JSON parse failed:', error);
      return [];
    }
  }

  function getSelectedOptions(form) {
    if (!form) return [];

    var selected = [];

    $$('fieldset', form).forEach(function (fieldset) {
      var checked = $('input[type="radio"]:checked', fieldset);
      if (checked) {
        selected.push(checked.value);
      }
    });

    if (selected.length) return selected;

    $$('input[type="radio"][name^="options["]:checked', form).forEach(function (input) {
      selected.push(input.value);
    });

    return selected;
  }

  function findVariant(variants, selectedOptions) {
    if (!variants.length || !selectedOptions.length) return null;

    return variants.find(function (variant) {
      var opts = variant.options || [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter(Boolean);

      if (opts.length !== selectedOptions.length) return false;

      return opts.every(function (opt, index) {
        return normalize(opt) === normalize(selectedOptions[index]);
      });
    }) || null;
  }

  function ensureVariantInput(form, variant) {
    if (!form || !variant) return;

    var input = $('input[name="id"]', form);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      form.appendChild(input);
    }

    input.value = variant.id;
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    return '$' + value.toFixed(2);
  }

  function updatePrice(variant) {
    if (!variant) return;

    var priceText = variant.price ? formatMoney(variant.price) : '';

    $$('[data-mobile-sku-price], [data-product-price], .cm-price, .cm-pdp-price').forEach(function (el) {
      if (priceText) {
        el.textContent = priceText;
      }
    });
  }

  function updateSelectedLabels(form) {
    if (!form) return;

    $$('fieldset', form).forEach(function (fieldset) {
      var checked = $('input[type="radio"]:checked', fieldset);
      var label =
        $('[data-selected-option]', fieldset) ||
        fieldset.querySelector('.cm-selected-value');

      if (checked && label) {
        label.textContent = checked.value;
      }
    });
  }

  function updateButton(variant) {
    var buttons = $$('[data-add-button], .cm-add');

    buttons.forEach(function (button) {
      if (!variant) return;

      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim() || 'Add to Cart';
      }

      if (variant.available === false) {
        button.disabled = true;
        button.textContent = 'Sold Out';
      } else {
        button.disabled = false;
        button.textContent = button.dataset.originalText;
      }
    });
  }

  function getVariantMediaId(variant) {
    if (!variant) return null;

    if (variant.media_id) {
      return String(variant.media_id);
    }

    if (variant.featured_media && variant.featured_media.id) {
      return String(variant.featured_media.id);
    }

    if (variant.featured_image && variant.featured_image.id) {
      return String(variant.featured_image.id);
    }

    if (variant.image_id) {
      return String(variant.image_id);
    }

    return null;
  }

  function getVariantImage(variant) {
    if (!variant) return '';

    if (variant.image_url) {
      return variant.image_url;
    }

    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (variant.featured_image && variant.featured_image.url) {
      return variant.featured_image.url;
    }

    if (variant.image) {
      return variant.image;
    }

    return '';
  }

  function activateGalleryByMediaId(mediaId) {
    if (!mediaId) return false;

    var panel =
      $('[data-pdp-panel][data-media-id="' + mediaId + '"]') ||
      $('[data-media-id="' + mediaId + '"]');

    if (!panel) return false;

    $$('[data-pdp-panel]').forEach(function (el) {
      el.classList.remove('is-active');
    });

    panel.classList.add('is-active');

    $$('[data-pdp-thumb], .cm-pdp-thumb').forEach(function (el) {
      el.classList.remove('is-active');
    });

    var thumb =
      $('[data-pdp-thumb][data-thumb-media-id="' + mediaId + '"]') ||
      $('[data-thumb-media-id="' + mediaId + '"]');

    if (thumb) {
      thumb.classList.add('is-active');
    }

    return true;
  }

  function setMainImage(src) {
    if (!src) return;

    var activePanel =
      $('.cm-pdp-panel.is-active') ||
      $('[data-pdp-panel].is-active') ||
      $('.cm-pdp-panel') ||
      $('[data-pdp-panel]');

    var img =
      activePanel && $('img', activePanel) ||
      $('.cm-pdp-main-image') ||
      $('.cm-pdp-media img');

    if (!img) return;

    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    var parentPanel = img.closest('[data-pdp-panel], .cm-pdp-panel');

    if (parentPanel) {
      $$('[data-pdp-panel], .cm-pdp-panel').forEach(function (panel) {
        panel.classList.remove('is-active');
      });
      parentPanel.classList.add('is-active');
    }
  }

  function updateGallery(variant) {
    if (!variant) return;

    var mediaId = getVariantMediaId(variant);
    var image = getVariantImage(variant);

    if (mediaId && activateGalleryByMediaId(mediaId)) {
      return;
    }

    if (image) {
      setMainImage(image);
    }
  }

  function setupGalleryThumbs() {
    $$('[data-pdp-thumb], .cm-pdp-thumb').forEach(function (thumb) {
      if (thumb.dataset.cmBound === '1') return;
      thumb.dataset.cmBound = '1';

      thumb.addEventListener('click', function () {
        var mediaId =
          thumb.getAttribute('data-thumb-media-id') ||
          thumb.dataset.thumbMediaId;

        if (mediaId && activateGalleryByMediaId(mediaId)) {
          return;
        }

        var img = $('img', thumb);

        if (img && img.src) {
          setMainImage(img.src);
        }

        $$('[data-pdp-thumb], .cm-pdp-thumb').forEach(function (el) {
          el.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
      });
    });
  }

  function setupQuantityButtons() {
    document.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-qty-minus], .cm-qty-minus');
      var plus = event.target.closest('[data-qty-plus], .cm-qty-plus');

      if (!minus && !plus) return;

      var wrapper =
        event.target.closest('.cm-qty') ||
        event.target.closest('.cm-quantity') ||
        event.target.closest('.quantity') ||
        document;

      var input =
        $('[data-qty-input]', wrapper) ||
        $('input[name="quantity"]', wrapper) ||
        $('input[type="number"]', wrapper);

      if (!input) return;

      var current = parseInt(input.value || '1', 10);
      if (isNaN(current)) current = 1;

      if (minus) current = Math.max(1, current - 1);
      if (plus) current = current + 1;

      input.value = current;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function setupVariants() {
    var root = getProductRoot();
    var form = getProductForm(root);
    var variants = readVariantData();

    if (!form || !variants.length) return;

    function refresh() {
      var selectedOptions = getSelectedOptions(form);
      var variant = findVariant(variants, selectedOptions);

      if (!variant) return;

      ensureVariantInput(form, variant);
      updateSelectedLabels(form);
      updatePrice(variant);
      updateButton(variant);
      updateGallery(variant);
    }

    form.addEventListener('change', function (event) {
      if (
        event.target.matches('input[type="radio"]') ||
        event.target.matches('select')
      ) {
        setTimeout(refresh, 20);
      }
    });

    form.addEventListener('click', function (event) {
      if (event.target.matches('input[type="radio"]') || event.target.closest('label')) {
        setTimeout(refresh, 60);
      }
    });

    refresh();
  }

  function setupSmoothAnchors() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href');
      if (!id || id === '#') return;

      var target = document.querySelector(id);
      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  function init() {
    setupGalleryThumbs();
    setupQuantityButtons();
    setupVariants();
    setupSmoothAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ===== Mobile PDP SKU image switch fix ===== */
(function () {
  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function clean(value) {
    return String(value || '').trim().toLowerCase();
  }

  function readVariantMap() {
    var el = $('[data-cm-variant-map]') || $('[data-product-variants]');
    if (!el) return [];

    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      console.warn('Mobile variant map parse error:', e);
      return [];
    }
  }

  function isVisible(el) {
    if (!el) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getSelectedOptionsMobile() {
    var root =
      $('.cm-sku-panel') ||
      $('form[action*="/cart/add"]') ||
      document;

    var fieldsets = $$('fieldset', root);

    var visibleFieldsets = fieldsets.filter(function (fieldset) {
      return isVisible(fieldset) && $('input[type="radio"]:checked', fieldset);
    });

    var usableFieldsets = visibleFieldsets.length ? visibleFieldsets : fieldsets;

    usableFieldsets.sort(function (a, b) {
      return Number(a.getAttribute('data-option-index') || 0) - Number(b.getAttribute('data-option-index') || 0);
    });

    var selected = [];

    usableFieldsets.forEach(function (fieldset) {
      var checked = $('input[type="radio"]:checked', fieldset);
      if (checked) {
        selected.push(checked.value);
      }
    });

    if (selected.length) return selected;

    $$('input[type="radio"]:checked', root).forEach(function (input) {
      selected.push(input.value);
    });

    return selected;
  }

  function findVariant(variants, selected) {
    if (!variants.length || !selected.length) return null;

    return variants.find(function (variant) {
      var options = variant.options || [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter(Boolean);

      if (options.length !== selected.length) return false;

      return options.every(function (option, index) {
        return clean(option) === clean(selected[index]);
      });
    }) || null;
  }

  function updateHiddenVariantId(variant) {
    var form = $('form[action*="/cart/add"]');
    if (!form || !variant || !variant.id) return;

    var input = $('input[name="id"]', form);
    if (input) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function switchMainImage(variant) {
    if (!variant) return;

    var mediaId = variant.media_id || null;
    var imageUrl =
      variant.image_url ||
      (variant.featured_image && variant.featured_image.src) ||
      (variant.featured_image && variant.featured_image.url) ||
      variant.image ||
      '';

    if (mediaId) {
      var panel =
        $('[data-pdp-panel][data-media-id="' + mediaId + '"]') ||
        $('[data-media-id="' + mediaId + '"]');

      if (panel) {
        $$('[data-pdp-panel], .cm-pdp-panel').forEach(function (item) {
          item.classList.remove('is-active');
        });

        panel.classList.add('is-active');

        $$('[data-pdp-thumb], .cm-pdp-thumb').forEach(function (thumb) {
          thumb.classList.remove('is-active');
        });

        var thumb =
          $('[data-pdp-thumb][data-thumb-media-id="' + mediaId + '"]') ||
          $('[data-thumb-media-id="' + mediaId + '"]');

        if (thumb) {
          thumb.classList.add('is-active');
        }

        return;
      }
    }

    if (imageUrl) {
      var img =
        $('.cm-pdp-panel.is-active img') ||
        $('[data-pdp-panel].is-active img') ||
        $('.cm-pdp-main-image') ||
        $('.cm-pdp-media img');

      if (img) {
        img.src = imageUrl;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
    }
  }

  function updateMobilePreview(variant) {
    if (!variant) return;

    var preview = $('[data-mobile-sku-preview]');
    if (!preview) return;

    var imageUrl =
      variant.image_url ||
      (variant.featured_image && variant.featured_image.src) ||
      (variant.featured_image && variant.featured_image.url) ||
      variant.image ||
      '';

    var img = $('[data-mobile-sku-image]', preview);
    var title = $('[data-mobile-sku-title]', preview);
    var price = $('[data-mobile-sku-price]', preview);

    if (img && imageUrl) {
      img.src = imageUrl;
      img.removeAttribute('srcset');
      img.style.objectFit = 'contain';
    }

    if (title) {
      title.textContent = variant.title || (variant.options ? variant.options.join(' / ') : '');
    }

    if (price && variant.price) {
      price.textContent = '$' + (Number(variant.price) / 100).toFixed(2);
    }
  }

  function refreshMobileVariant() {
    var variants = readVariantMap();
    var selected = getSelectedOptionsMobile();
    var variant = findVariant(variants, selected);

    if (!variant) return;

    updateHiddenVariantId(variant);
    switchMainImage(variant);
    updateMobilePreview(variant);
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('.cm-sku-panel input[type="radio"]') ||
      event.target.matches('form[action*="/cart/add"] input[type="radio"]')
    ) {
      setTimeout(refreshMobileVariant, 40);
      setTimeout(refreshMobileVariant, 180);
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.cm-sku-panel label') ||
      event.target.closest('.cm-sku-panel input[type="radio"]') ||
      event.target.closest('form[action*="/cart/add"] label')
    ) {
      setTimeout(refreshMobileVariant, 80);
      setTimeout(refreshMobileVariant, 240);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(refreshMobileVariant, 300);
  });
})();